import { Box } from "@mui/material";
import * as React from "react";
import ContactEnquiryList from "./ContactEnquiryList";

export default function ContactEnquiry() {
  return (
    <Box sx={{ width: "100%" }} className="container container-h-full">
      <Box>
        <div className="content-subheader">
          <h2 className="font-weight-bolder">Contact Enquiry List</h2>
        </div>
      </Box>
      <div className="sub-content-sec recently-blog">
        <ContactEnquiryList></ContactEnquiryList>
      </div>
    </Box>
  );
}
